import type { VNode } from 'vue';

type TSkeletonBone<T> = T | TSkeletonBone<T>[];

export type TSkeletonBones = TSkeletonBone<VNode>;
export type TSkeletonLoaderType = keyof typeof allowedTypes;

export const allowedTypes = {
  actions: 'button@2',
  article: 'heading, paragraph',
  avatar: 'avatar',
  button: 'button',
  card: 'block, heading',
  'card-avatar': 'block, list-item-avatar',
  chip: 'chip',
  'date-picker': 'date-picker-options, date-picker-days, list-item',
  'date-picker-options': 'actions',
  'date-picker-days': 'avatar@42',
  divider: 'divider',
  heading: 'heading',
  block: 'block',
  'list-item': 'text',
  'list-item-avatar': 'avatar, text',
  'list-item-two-line': 'sentences',
  'list-item-avatar-two-line': 'avatar, sentences',
  'list-item-three-line': 'paragraph',
  'list-item-avatar-three-line': 'avatar, paragraph',
  paragraph: 'text@3',
  sentences: 'text@2',
  subtitle: 'text',
  table: 'table-heading, table-thead, table-tbody, table-tfoot',
  'table-heading': 'chip, text',
  'table-thead': 'heading@6',
  'table-tbody': 'table-row-divider@6',
  'table-row-divider': 'table-row, divider',
  'table-row': 'text@6',
  'table-tfoot': 'text@2, actions',
  text: 'text'
} as const;
